var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D70B29",
    d: "M42.533 6.157s.329.16.44.418c.071.167.144 1.506.056 1.647-.11.175-.627.44-.627.44l.133-2.504h-.002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M42.992 7.995c-.008.154-.024.186-.026.19-.065.105-.32.261-.49.356l.12-2.264c.1.065.247.179.31.326.049.115.108.968.086 1.392Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D70B29",
    d: "M41.788 20.215s.343-.126.48-.37c.09-.158.304-1.481.23-1.63-.09-.187-.576-.504-.576-.504l-.132 2.504h-.002Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M42.438 18.436c-.023.426-.172 1.268-.233 1.375-.078.14-.237.238-.343.291l.12-2.264c.16.113.397.295.45.406 0 .002.014.038.006.192Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m25.134 12.284-.013.246-.371 6.991.697.037.371-6.99.013-.247.385-7.244-.698-.037-.384 7.244Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M10.828 19.823c1.311.07 1.916-.373 1.916-.373l-8.393-1.17-1.499-.403c.868 1.631 2.754 1.668 2.754 1.668l5.224.277h-.002Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M11.707 3.268c1.31.07 1.865.574 1.865.574l-8.47.272-1.532.242c1.035-1.53 2.914-1.367 2.914-1.367l5.225.277-.002.002Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M4.194 3.896c-.604.31-1.175.89-1.834 2.686-.74 2.018-.882 4.441-.882 4.441v.006s-.115 2.424.407 4.508c.465 1.857.971 2.493 1.539 2.864.567.372 1.763.646 4.878.811l8.808.468c3.648.193 7.716.216 7.716.216l.808-15.219s-4.049-.408-7.696-.601l-8.81-.468c-3.115-.165-4.333-.019-4.937.29l.003-.002Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M4.194 3.896c-.604.31-1.175.89-1.834 2.686-.74 2.018-.882 4.441-.882 4.441v.006s-.115 2.424.407 4.508c.465 1.857.971 2.493 1.539 2.864.567.372 1.763.646 4.878.811l.423.023c-3.115-.166-4.31-.44-4.879-.811-.567-.371-1.073-1.01-1.539-2.865-.522-2.083-.407-4.507-.407-4.507v-.006s.143-2.423.882-4.44c.66-1.796 1.23-2.376 1.834-2.685.604-.31 1.822-.456 4.937-.29l-.423-.023c-3.115-.165-4.333-.019-4.937.29v-.002Z",
    opacity: 0.75
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M14.612 19.135s.84-.257 1.72-.555c.933-.315 1.735-.647 2.007-.633l2.822.15c.34.018.283 1.318-.045 1.3-.926-.049-6.504-.262-6.504-.262Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M3.284 13.766c.047.377.11.725.187 1.04.396 1.604.767 1.85.946 1.969.392.26 1.663.449 3.778.561l3.396.18c-.028-.062-.057-.137-.09-.217l-3.21-.17c-2.135-.114-3.418-.304-3.814-.564-.18-.118-.556-.364-.956-1.968a8.722 8.722 0 0 1-.16-.829c-.026-.001-.052 0-.077-.002Z",
    opacity: 0.84
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M3.56 8.546c.087-.37.188-.71.297-1.015.563-1.553.958-1.759 1.149-1.857.417-.216 1.701-.268 3.816-.156l3.396.18c-.034.06-.072.13-.113.207l-3.21-.17c-2.134-.114-3.43-.062-3.852.156-.192.098-.591.303-1.158 1.856-.09.248-.174.517-.248.807-.026-.001-.051-.005-.077-.006v-.002Z",
    opacity: 0.84
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m23.86 18.394-.054 1.018c-.004.077-.065.137-.134.133l-1.621-.086c-.069-.004-.122-.07-.118-.146l.054-1.018c.004-.077.064-.137.133-.133l1.621.086c.07.003.123.07.119.146Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0A500",
    d: "m24.669 6.228-.32 6.015-.006.122-.312 5.884.793 1.647.397-7.485.007-.122.404-7.612-.963 1.551Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3A3A",
    d: "M19.134 19.558a.07.07 0 0 0-.067-.074l-.364-.02a.07.07 0 0 0-.074.068l-.005.1a.173.173 0 0 0 .047.119l.232.22c.028.028.082.05.122.053l1.334.07a.242.242 0 0 0 .128-.036l.293-.2a.158.158 0 0 0 .06-.108l.006-.1a.07.07 0 0 0-.067-.075l-.364-.02a.07.07 0 0 0-.074.067l-.012.228c-.002.032-.035.058-.074.056l-1.071-.057c-.04-.002-.07-.03-.068-.063l.012-.228h.006Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m25.049 19.716-.008.15s2.15.3 4.87.444l7.915.42c2.192.116 3.934-.003 3.934-.003l.007-.123-16.718-.887Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m26.013 5.78-.693 13.064-.271.873 16.718.887s.466-2.883.706-7.397c.24-4.515.081-7.437.081-7.437l-16.718-.887.177.897Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m26.042 12.333-.364 6.85 15.513.823s.385-2.308.625-6.838.103-6.872.103-6.872l-15.513-.823-.364 6.86Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M15.396 4.35s.808.345 1.652.735c.895.412 1.657.827 1.929.841l2.822.15c.34.018.42-1.28.093-1.298-.926-.049-6.496-.427-6.496-.427Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m24.514 6.067.054-1.019c.004-.076-.05-.142-.119-.146l-1.621-.086c-.069-.003-.13.056-.133.133l-.054 1.018c-.004.077.05.145.118.148l1.622.086c.068.004.129-.056.133-.134Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#313433",
    d: "M13.514 4.04a1.114 1.114 0 0 1 2.076.11l-2.075-.11Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A3A3A",
    d: "M19.938 4.41a.07.07 0 0 1-.075.068l-.363-.02a.07.07 0 0 1-.067-.074l.005-.1a.172.172 0 0 1 .06-.114l.254-.195a.217.217 0 0 1 .126-.039l1.335.071a.24.24 0 0 1 .123.05l.27.23a.16.16 0 0 1 .05.114l-.006.1a.07.07 0 0 1-.075.067l-.363-.019a.07.07 0 0 1-.067-.074l.012-.228c.002-.032-.029-.061-.068-.063l-1.071-.057c-.04-.002-.072.022-.074.055l-.012.228h.006Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m25.105 6.143-.325 6.123-.007.131-.318 5.985.29.382.336-6.35.007-.132.345-6.488-.328.35Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M17.613 8.744c-.42 1.62-.396 2.941-.39 3.117-.025.174-.19 1.486.058 3.14.287 1.912.898 2.656.898 2.656l5.493.291a.14.14 0 0 0 .147-.134l.297-5.585-.055-.003.055-.003.297-5.586a.14.14 0 0 0-.133-.147l-5.493-.292s-.688.673-1.174 2.546Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M25.795 9.483a2.04 2.04 0 0 0-.4-.332l.09-1.71s.235-.11.434-.289c.196-.176.323-.347.323-.347L26.08 9.86s-.106-.18-.285-.38v.002Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M25.988 11.563s-.11.095-.362.162c-.214.06-.373.047-.373.047l-.054 1.024s.16.007.366.087c.241.095.342.2.342.2l.081-1.524v.004Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "m25.836 4.883.008-.15s2.17-.07 4.89.075l7.915.42c2.191.116 3.912.419 3.912.419l-.007.123-16.718-.887Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M4.436 5.413c-.207.125-.637.382-1.26 2.316-.368 1.143-.574 2.43-.686 3.338v.016l-.001.018c.016.915.087 2.215.332 3.391.413 1.987.815 2.29 1.008 2.437.423.32 1.796.543 4.084.664l3.674.195a15.029 15.029 0 0 1-.8-3.42c-.062-.542-.047-1.692.014-2.842.061-1.15.168-2.295.286-2.827a14.923 14.923 0 0 1 1.158-3.317l-3.673-.195c-2.288-.121-3.678-.045-4.132.228l-.004-.002Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M5.992 6.997c-.16.093-.49.282-.968 1.711-.281.845-.474 1.51-.525 2.48-.052.968.07 1.649.26 2.518.322 1.47.631 1.695.781 1.804.327.236 1.386.405 3.15.498l2.83.15a10.723 10.723 0 0 1-.621-2.532c-.048-.4-.038-1.25.007-2.099.045-.85.125-1.698.215-2.09.269-1.16.672-2.037.885-2.451l-2.83-.15c-1.763-.094-2.834-.04-3.184.161Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M4.685 4.43c-.23.12-.709.37-1.39 2.247-.409 1.125-.696 2.642-.79 4.403-.093 1.76.034 3.303.32 4.465.476 1.94.927 2.24 1.144 2.38.476.316 2.013.543 4.572.679l4.108.218c-.02-.044-.038-.093-.06-.143l-3.692-.196c-2.546-.135-4.075-.36-4.547-.67-.216-.14-.663-.432-1.14-2.334-.284-1.139-.41-2.653-.32-4.379.092-1.726.378-3.214.782-4.318.675-1.84 1.151-2.086 1.38-2.204.502-.257 2.047-.319 4.592-.184l3.693.196c.027-.047.053-.093.075-.136l-4.108-.218c-2.56-.135-4.114-.072-4.618.191v.004Z",
    opacity: 0.2,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M11.766 17s-1.83 1.246-4.223 1.255c-4.37.015-5.349-2.5-5.517-2.196.065.224.131.426.199.61 0 .003.003.007.005.011l.036.095c.002.006.006.012.007.018l.035.089.007.02c.012.028.022.056.035.084.001.006.005.012.007.018.012.029.022.055.035.083l.005.012.037.083c.055.117.112.227.168.324l.002.004c.012.02.023.041.036.061l.009.015c.01.018.022.036.033.053.003.006.009.012.013.018.01.017.021.033.03.05.006.005.01.013.015.02.011.014.02.03.031.045.006.006.01.014.015.02l.031.043.015.019.031.04c.004.007.01.011.013.017a.643.643 0 0 0 .034.04l.005.006c.024.028.048.055.075.082l.01.013c.01.01.02.018.029.029l.02.02.027.026c.007.008.015.014.022.023.007.008.017.014.024.023.008.008.017.014.025.023.007.006.015.014.024.02l.027.022.022.019a.21.21 0 0 1 .027.02l.023.018.03.021.019.015.034.023a.176.176 0 0 0 .015.011c.018.01.035.024.05.034.568.371 1.763.646 4.878.81 3.654.195 3.465-2.212 3.465-2.212l.005.002Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M12.34 6.175S10.654 4.742 8.275 4.48C3.929 4.002 2.69 6.4 2.556 6.08c.088-.215.175-.41.261-.584 0-.004.005-.008.007-.012.015-.03.03-.061.046-.09.002-.006.007-.012.009-.017l.044-.085c.002-.006.006-.011.009-.017l.043-.08.01-.018c.014-.027.027-.052.043-.078l.006-.012.046-.078a4.62 4.62 0 0 1 .201-.305l.002-.004.043-.057c.004-.003.006-.01.01-.013l.038-.049.015-.017.036-.045c.006-.006.01-.014.017-.02.012-.014.023-.028.036-.04l.016-.02.036-.039.017-.017.035-.037c.004-.006.01-.01.015-.015l.037-.036.006-.005c.027-.027.054-.05.083-.075l.012-.011c.01-.01.021-.017.031-.026.009-.005.015-.013.023-.018l.029-.023.025-.02.026-.02c.009-.008.019-.013.027-.02.008-.006.016-.013.027-.019a.134.134 0 0 1 .028-.018l.025-.016.028-.019.025-.014c.01-.005.02-.013.032-.02l.02-.013a.341.341 0 0 1 .037-.02l.016-.01.053-.03c.604-.308 1.822-.454 4.937-.29 3.654.195 3.21 2.568 3.21 2.568h.007Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M13.325 4.53a.329.329 0 0 0-.216.133 12.164 12.164 0 0 0-1.327 3.233c-.48 1.904-.59 3.64-.59 3.64v.007s-.074 1.74.201 3.684c.243 1.704.793 2.967.977 3.355a.317.317 0 0 0 .2.155c.297.06.837.175 1.54.078 1.481-.204 2.96-.95 3.388-1.182a.154.154 0 0 0 .065-.196c-.154-.357-.577-1.412-.678-2.588-.136-1.57-.016-3.005-.016-3.005v-.006s.033-1.439.334-2.986c.225-1.159.755-2.164.949-2.502a.153.153 0 0 0-.045-.202c-.401-.273-1.792-1.173-3.243-1.534-.69-.17-1.238-.113-1.54-.085v.002Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M17.848 6.316c-.242.442-.71 1.393-.922 2.484a20.255 20.255 0 0 0-.338 3.027c-.001.016-.01.13-.02.316-.03.533-.062 1.593.036 2.73.097 1.109.46 2.102.654 2.568-.515.268-1.856.912-3.186 1.094a4.071 4.071 0 0 1-1.422-.07h-.015l-.014-.013a11.9 11.9 0 0 1-.948-3.265 22.498 22.498 0 0 1-.197-3.633c0-.018.114-1.737.58-3.59.413-1.634 1.084-2.812 1.289-3.146a.062.062 0 0 1 .014-.01l.016.001c.3-.03.796-.076 1.42.08 1.304.323 2.57 1.104 3.053 1.425v.002Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M5.623 18.45a.416.416 0 0 1-.027.128c-.09.251-.4.387-.688.3-.405-.118-.721-.253-.963-.41-.465-.3-1.015-.785-1.549-2.09a.685.685 0 0 1-.049-.275.525.525 0 0 1 .26-.443.436.436 0 0 1 .363-.026.57.57 0 0 1 .323.328c.434 1.078.846 1.45 1.189 1.674.17.11.408.207.729.3.252.073.422.283.41.511l.002.002Z",
    opacity: 0.75
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M5.54 18.488a.292.292 0 0 1-.019.092c-.069.19-.309.289-.536.222-.407-.12-.721-.254-.963-.41-.465-.301-1.013-.785-1.552-2.103a.573.573 0 0 1-.04-.223.395.395 0 0 1 .194-.338.304.304 0 0 1 .257-.018c.108.039.2.132.25.26.467 1.155.915 1.562 1.292 1.804.189.123.447.229.796.33.198.058.33.215.321.384Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M5.026 18.662c-.394-.116-.697-.244-.925-.392-.45-.29-.975-.764-1.497-2.035-.06-.149-.018-.32.09-.378.109-.059.24.017.3.166.477 1.186.945 1.615 1.347 1.873.2.129.474.244.835.348.156.044.25.169.206.285-.042.116-.203.178-.358.133h.002Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M6.384 4.1a.416.416 0 0 0-.012-.131c-.063-.26-.358-.427-.653-.374-.416.077-.744.175-1.001.308-.495.25-1.093.673-1.762 1.915a.685.685 0 0 0-.077.267c-.01.195.07.37.212.469a.436.436 0 0 0 .357.064.572.572 0 0 0 .356-.292C4.35 5.3 4.8 4.97 5.164 4.788c.18-.091.428-.163.756-.222.259-.046.45-.237.462-.465l.002-.002Z",
    opacity: 0.75
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M6.306 4.054a.293.293 0 0 0-.009-.093c-.049-.196-.277-.32-.51-.28-.417.077-.744.176-1.001.306-.494.25-1.09.673-1.766 1.927a.573.573 0 0 0-.063.217c-.008.151.05.285.157.357a.314.314 0 0 0 .254.045.444.444 0 0 0 .276-.23c.587-1.1 1.075-1.456 1.476-1.658.2-.101.468-.18.827-.244.202-.034.35-.178.359-.347Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M5.814 3.825c-.404.073-.719.169-.962.292-.478.242-1.05.656-1.703 1.865-.077.141-.052.314.048.385.103.07.242.008.317-.133.6-1.13 1.11-1.506 1.538-1.72.212-.107.497-.193.867-.258.159-.027.266-.141.234-.261-.029-.12-.182-.2-.341-.17h.002Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#313433",
    d: "M12.707 19.247a1.113 1.113 0 0 0 2.076.11l-2.075-.11Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#724D44",
    d: "M14.12 4.786a5.01 5.01 0 0 0-.745.021h-.016s-.01.009-.014.01a11.903 11.903 0 0 0-1.288 3.147 22.503 22.503 0 0 0-.581 3.59 22.6 22.6 0 0 0 .197 3.633c.237 1.666.78 2.909.948 3.265l.014.01.015.001c.17.037.404.083.693.1.14-.45.271-.951.393-1.495.055.04.11.065.171.069.44.023.853-1.027.923-2.348.058-1.085-.135-2.014-.45-2.322.02-.28.04-.562.055-.847.14-2.661.01-5.08-.316-6.834Z",
    opacity: 0.22
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M15.456 18.87c-.49.158-.844.267-.844.267s5.578.213 6.504.262c.163.009.259-.307.272-.63a32.887 32.887 0 0 0-.988-.066c-1.983-.105-3.763-.032-4.946.167h.002Z",
    opacity: 0.66
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M16.207 4.697c-.47-.208-.81-.354-.81-.354s5.57.378 6.495.427c.163.01.224.334.204.656a32.53 32.53 0 0 1-.99-.039c-1.983-.105-3.745-.366-4.9-.69h.001Z",
    opacity: 0.66
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M13.375 4.807h-.015s-.01.009-.015.01a11.898 11.898 0 0 0-1.288 3.147 22.828 22.828 0 0 0-.549 3.201c1.128-.405 2.43-.604 3.803-.531.46.024.906.077 1.34.158.049-.552.132-1.259.275-1.994.214-1.093.68-2.042.922-2.484-.483-.321-1.749-1.104-3.052-1.425a3.993 3.993 0 0 0-1.42-.082Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M11.627 14.843c.013.115.029.23.046.346a11.88 11.88 0 0 0 .949 3.265c.003.004.01.008.013.01l.016.001c.294.061.784.16 1.42.072 1.331-.184 2.672-.826 3.187-1.095-.194-.465-.56-1.46-.654-2.567a20.27 20.27 0 0 1-.016-3.046c.002-.028.003-.138.013-.317.011-.208.03-.497.062-.838a9.282 9.282 0 0 0-5.034 4.171l-.002-.002Z",
    opacity: 0.1,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M21.387 18.594c-.014-.263-.086-.49-.226-.497l-2.822-.15c-.09-.005-.244.03-.44.091.803.28 1.846.479 2.994.54.167.008.33.013.492.016h.002Z",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M22.076 5.6c-.04.26-.137.478-.277.47l-2.822-.15c-.09-.004-.24-.056-.428-.137.828-.192 1.887-.28 3.035-.219.167.009.33.022.49.034l.002.002Z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m14.55 20.184-.23-.408a.142.142 0 0 0-.193-.054l-.152.087a.142.142 0 0 0-.054.192l.301.53s.071 1.185.35 1.64c.278.454.823.3.89.26l.378-.215a.142.142 0 0 0 .053-.193l-.977-1.723c-.037-.067-.119-.095-.182-.059-.06.037-.142.009-.182-.059l-.002.002Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M14.912 20.3c-.037-.067-.119-.095-.182-.059a.102.102 0 0 1-.058.015l1.131 1.98.033-.018a.142.142 0 0 0 .053-.193l-.977-1.723V20.3Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "m15.44 3.401-.272.382a.142.142 0 0 1-.197.033l-.142-.102a.142.142 0 0 1-.033-.197l.356-.496s.196-1.17.522-1.592c.324-.422.848-.21.911-.165l.353.254a.142.142 0 0 1 .033.197l-1.154 1.612c-.044.062-.128.082-.187.04-.057-.041-.14-.024-.188.038l-.001-.004Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M15.814 3.322c-.045.063-.129.082-.188.04a.103.103 0 0 0-.056-.02l1.334-1.848.03.021a.142.142 0 0 1 .033.197l-1.154 1.612v-.002Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M25.495 15.134c-.197.177-.433.288-.433.288l-.09 1.71a2.098 2.098 0 0 0 .685.713l.162-3.056s-.125.168-.324.347v-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "m38.005 19.836 3.186.17s.385-2.308.625-6.838.103-6.872.103-6.872l-3.186-.169-.728 13.71Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "m26.406 5.475 3.186.17s.138 2.334-.102 6.865c-.24 4.53-.626 6.843-.626 6.843l-3.186-.169.728-13.709Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "m41.363 18.783.054-.382-15.653-.83-.02.383 15.619.829Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "m41.427 17.578.054-.382-15.653-.83-.02.383 15.619.829Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "m41.49 16.373.055-.381-15.653-.831-.02.383 15.619.83Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "m41.555 15.168.054-.381-15.653-.83-.02.382 15.619.83Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "m41.619 13.963.053-.381-15.652-.83-.02.383 15.619.829Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "m41.683 12.758.053-.381-15.652-.83-.02.383 15.619.829Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "m41.747 11.554.053-.382-15.653-.83-.02.383 15.62.829Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "m41.81 10.349.054-.382-15.653-.83-.02.383 15.62.829Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "m41.874 9.146.054-.381-15.653-.831-.02.383 15.62.83Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "m41.938 7.941.054-.381-15.653-.83-.02.382 15.62.83Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#606060",
    d: "m35.193 18.757-.05.931-5.005-.265.05-.932a.703.703 0 0 1 .74-.664l3.6.191c.39.02.686.352.665.739Zm.629-11.846.05-.932-5.007-.265-.05.931c-.02.39.278.72.667.741l3.6.191c.39.021.72-.277.74-.666Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "m35.822 6.911.05-.932-5.007-.265-.05.931c-.02.39.278.72.667.741l3.6.191c.39.021.72-.277.74-.666Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "m35.193 18.757-.05.931-5.005-.265.05-.932a.705.705 0 0 1 .74-.666l3.601.191a.7.7 0 0 1 .664.74Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 42.72,
    x2: 42.84,
    y1: 8.552,
    y2: 6.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E41F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.11,
    x2: 1.23,
    y1: 17.94,
    y2: 15.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E41F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 7.746,
    x2: 7.859,
    y1: 19.66,
    y2: 17.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFD72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 8.622,
    x2: 8.518,
    y1: 3.15,
    y2: 5.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFD72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 12.939,
    x2: 13.767,
    y1: 19.458,
    y2: 3.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FFD833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB647"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 4.892,
    x2: 5.72,
    y1: 19.031,
    y2: 3.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C3B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C3B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#C3B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 17.982,
    x2: 18.056,
    y1: 19.314,
    y2: 17.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 22.861,
    x2: 22.93,
    y1: 19.504,
    y2: 18.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 33.39,
    x2: 33.408,
    y1: 20.494,
    y2: 20.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFD72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 25.442,
    x2: 42.473,
    y1: 12.301,
    y2: 13.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFCC4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 33.566,
    x2: 34.293,
    y1: 19.601,
    y2: 5.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1.87,
    x2: 1.796,
    y1: 3.633,
    y2: 5.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 23.638,
    x2: 23.569,
    y1: 4.859,
    y2: 6.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 24.589,
    x2: 25.277,
    y1: 18.756,
    y2: 5.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 24.334,
    x2: 17.416,
    y1: 12.238,
    y2: 11.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 25.719,
    x2: 25.881,
    y1: 9.842,
    y2: 6.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFCC4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 25.547,
    x2: 25.628,
    y1: 13.067,
    y2: 11.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFCC4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 34.195,
    x2: 34.213,
    y1: 5.327,
    y2: 4.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFD72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 7.887,
    x2: 8.374,
    y1: 15.966,
    y2: 6.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 7.388,
    x2: 8.15,
    y1: 18.543,
    y2: 4.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 6.852,
    x2: 7.003,
    y1: 17.421,
    y2: 14.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFE370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFD836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 1.801,
    x2: 1.65,
    y1: 4.934,
    y2: 7.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFE370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFD836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 14.147,
    x2: 14.878,
    y1: 18.608,
    y2: 4.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 5.29,
    x2: 2.314,
    y1: 18.968,
    y2: 15.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 4.283,
    x2: 3.142,
    y1: 18.553,
    y2: 13.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F7EA78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F9F09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBF4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FCF8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FEFDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 3.875,
    x2: 4.092,
    y1: 19.529,
    y2: 15.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 5.589,
    x2: 2.265,
    y1: 3.812,
    y2: 7.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 5.05,
    x2: 3.405,
    y1: 3.852,
    y2: 8.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F7EA78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F9F09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBF4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FCF8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FEFDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 4.75,
    x2: 4.493,
    y1: 2.839,
    y2: 7.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 17.937,
    x2: 18.009,
    y1: 20.955,
    y2: 18.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 18.895,
    x2: 18.729,
    y1: 2.887,
    y2: 5.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 13.486,
    x2: 15.058,
    y1: 14.384,
    y2: 6.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 13.249,
    x2: 15.197,
    y1: 22.082,
    y2: 12.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 19.6,
    x2: 19.657,
    y1: 19.703,
    y2: 17.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 20.417,
    x2: 20.281,
    y1: 4.308,
    y2: 6.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 15.032,
    x2: 13.791,
    y1: 20.943,
    y2: 21.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 16,
    x2: 14.84,
    y1: 2.696,
    y2: 1.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 25.295,
    x2: 25.457,
    y1: 17.824,
    y2: 14.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFCC4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 38.695,
    x2: 42.143,
    y1: 13,
    y2: 13.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 25.773,
    x2: 29.22,
    y1: 12.314,
    y2: 12.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 24.531,
    x2: 40.182,
    y1: 17.696,
    y2: 18.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 24.595,
    x2: 40.246,
    y1: 16.491,
    y2: 17.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 24.659,
    x2: 40.31,
    y1: 15.287,
    y2: 16.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 24.723,
    x2: 40.374,
    y1: 14.084,
    y2: 14.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 24.787,
    x2: 40.438,
    y1: 12.879,
    y2: 13.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 24.851,
    x2: 40.502,
    y1: 11.674,
    y2: 12.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 24.915,
    x2: 40.566,
    y1: 10.47,
    y2: 11.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 24.979,
    x2: 40.63,
    y1: 9.265,
    y2: 10.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 25.043,
    x2: 40.694,
    y1: 8.06,
    y2: 8.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 25.107,
    x2: 40.758,
    y1: 6.855,
    y2: 7.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 35.828,
    x2: 30.822,
    y1: 6.797,
    y2: 6.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 35.187,
    x2: 30.181,
    y1: 18.871,
    y2: 18.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-86.962 10.58 2.55) scale(4.33206)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(93.038 -3.652 5.513) scale(4.33206)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.47936 -9.03325 5.96194 .31638 4.224 11.175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C4B700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEE00",
    stopOpacity: 0.44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarMarker);
export default __webpack_public_path__ + "static/media/car-marker.cfca9d993fd716917a72d6578f437d40.svg";
export { ForwardRef as ReactComponent };